import { useMemo as n } from "react";
const c = function(o, r) {
  return n(() => {
    const t = { ...o };
    for (const e of r)
      delete t[e];
    return t;
  }, [o, r]);
};
export {
  c as useOmitProps
};
//# sourceMappingURL=useOmitProps.mjs.map
